// extracted by mini-css-extract-plugin
module.exports = {"message":"BackgroundMessage_message__2e8OJ","inline":"BackgroundMessage_inline__18wS1"};